import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as yup from 'yup';
import moment from 'moment/moment';

import {
  formatDateTime,
  getDate,
  isEmpty,
  isEmptyObject,
  parseDateTime,
} from '../../../../utils/utils';
import {
  EnumOrderMerchantStatus,
  EnumOrderUpdateStatus,
  EnumRejectOrderReason,
  findEnumById,
} from '../../../../constants/enum';
import OutOfStockDishModal from './components/OutOfStockDishModal';
import { OrderDetailInfo } from './components/OrderDetailInfo';
import OrderDetailTable from './components/OrderDetailTable';
import { trans } from '../../../../localization/index';
import { OrderDetailAction } from './components/OrderDetailAction';
import Modal, {
  ModalAction,
  ModalBody,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import CustomerInfo from './components/CustomerInfo';
import RejectOrderModal from './RejectOrder/RejectOrderModal';
import RejectOrderDishModal from './RejectOrder/RejectOrderDishModal';
import RejectOrderBusyModal from './RejectOrder/RejectOrderBusyModal';
import {
  getRestaurantNextOpenTime,
  setEditDishOutOfStock,
  updateOrderDetail,
} from '../actions';
import RejectOrderRestaurantCloseModal from './RejectOrder/RejectOrderRestaurantCloseModal';
import { startConfirm } from '../../../../layout/components/UniversalModal/actions';
import RejectOrderCustomModal from './RejectOrder/RejectOrderCustomModal';
import TransferOrderModal from './TransferOrder/TransferOrderModal';
import { startTransferringOrder } from './TransferOrder/actions';

const FirstSeenUser = ({ firstSeenUser }) => {
  return (
    <div className="col-9">
      <h1 className="text-red font-weight-bold">
        {trans('mod_view_by', [firstSeenUser.name])}
      </h1>
    </div>
  );
};

const TitlePopupModal = ({ code, status, name, allowCancel }) => {
  const statusEnum = findEnumById(EnumOrderMerchantStatus, status);
  const { description } = statusEnum || {};

  return (
    <div>
      {name}
      &nbsp;
      <strong className="font-weight-bold" style={{ color: '#EE4D2D' }}>
        {code}
      </strong>
      <span>&nbsp;- {trans(description || '')}</span>
      {allowCancel === true && (
        <span>&nbsp;- {trans('allow_merchant_to_cancel')}</span>
      )}
    </div>
  );
};

const initialState = {
  pickTime: getDate(),
  merchantNote: '',
  outOfStockReq: {},
  rejectOrder: {
    rejectOrderReason: EnumRejectOrderReason.CHOOSE_OPTION.id,
    isRejectOrder: false,
    isOpenRestaurantClose: false,
  },
  outOfStockOrder: {
    dishes: [],
    toppings: [],
  },
  priceUpdateOrder: {
    dishes: [],
    toppings: [],
  },
  busyInfoOrder: {
    totalMinute: 0,
  },
  rejectCustomOrder: {
    customNote: '',
  },
};

class OrderDetailModal extends Component {
  state = initialState;

  componentDidMount() {
    const { itemDetail } = this.props;
    this.onResetState(itemDetail);
  }

  componentDidUpdate(prevProps) {
    const { itemDetail, isOpenDialog } = this.props;
    const { rejectOrder } = this.state;
    const { rejectOrderReason } = rejectOrder;
    if (isOpenDialog !== prevProps.isOpenDialog) {
      if (
        isOpenDialog ||
        rejectOrderReason !== EnumRejectOrderReason.CHOOSE_OPTION.id
      ) {
        this.onResetState(itemDetail);
      }
    }
  }

  onResetState = itemDetail => {
    const {
      pick_time: pickTime,
      merchant_note: merchantNote = '',
    } = itemDetail;

    const stateReset = {
      ...initialState,
      pickTime: !isEmptyObject(pickTime) ? parseDateTime(pickTime) : getDate(),
      merchantNote,
    };

    this.setState(stateReset);
  };

  handleChangeOutOfStock = outOfStockReq => {
    this.setState({
      outOfStockReq,
    });
  };

  // Dish and toppings
  handleOpenOutOfStockModal = ({ dishId, orderDishId, toppingId }) => {
    this.setState(previousState => {
      const { outOfStockOrder } = previousState;
      const { dishes = [], toppings = [] } = outOfStockOrder;
      if (toppingId > 0) {
        const currentTopping = toppings.find(
          topping => topping.toppingId === toppingId,
        );
        if (!isEmptyObject(currentTopping)) {
          const toppingNew = toppings.filter(
            topping => topping.toppingId !== toppingId,
          );
          return {
            outOfStockOrder: {
              ...previousState.outOfStockOrder,
              toppings: toppingNew,
            },
          };
        }
      } else {
        const currentDish = dishes.find(dish => dish.dishId === dishId);
        if (!isEmptyObject(currentDish)) {
          const dishesNew = dishes.filter(dish => dish.dishId !== dishId);
          return {
            outOfStockOrder: {
              ...previousState.outOfStockOrder,
              dishes: dishesNew,
            },
          };
        }
      }

      return {
        outOfStockReq: {
          dishId,
          toppingId,
          orderDishId,
          from: getDate(),
          to: moment()
            .add(1, 'hours')
            .toDate(),
        },
      };
    });
  };

  handleChangeMerchantNote = event => {
    const target = event.target || {};
    this.setState({
      merchantNote: target.value,
    });
  };

  handleChangePickTime = date => {
    this.setState({
      pickTime: date,
    });
  };

  handleUpdateOrder = (status, isUpdateInfo = false) => {
    const {
      updateOrderDetailConnect,
      itemDetail,
      setGeneralError,
    } = this.props;
    const objectValidate = {
      pickTime: this.state.pickTime,
      pickTimeOld: parseDateTime(itemDetail.pick_time),
      code: itemDetail.code,
      serial: itemDetail.serial,
    };

    function validate(req, dispatchGeneralError) {
      const schema = yup.object().shape({
        pickTime: yup
          .date()
          .min(yup.ref('pickTimeOld'), trans('mod_detail_invalid_pick_time'))
          .required(),
        code: yup.string().required(),
        serial: yup.string().required(),
      });
      try {
        schema.validateSync(req);
        return true;
      } catch (err) {
        dispatchGeneralError(err.errors[0]);
        return false;
      }
    }

    function genBody(state, orderDetail) {
      const {
        pickTime,
        merchantNote,
        rejectOrder,
        outOfStockOrder,
        priceUpdateOrder,
        busyInfoOrder,
        rejectCustomOrder,
      } = state;
      const { rejectOrderReason } = rejectOrder;
      const { code, restaurant, serial } = orderDetail;
      const reqParam = {
        order_code: code,
        serial,
        pick_time: formatDateTime(pickTime),
      };
      if (isUpdateInfo) {
        reqParam.merchant_note = merchantNote || '';
        reqParam.restaurant_id = !isEmptyObject(restaurant) ? restaurant.id : 0;
      }
      if (!isEmpty(status)) {
        reqParam.status = status;
      }

      switch (rejectOrderReason) {
        case EnumRejectOrderReason.CHOOSE_OPTION.id:
        case EnumRejectOrderReason.WRONG_MENU.id: {
          const {
            dishes: outOfStockDishes,
            toppings: outOfStockToppings,
          } = outOfStockOrder;
          const {
            dishes: updatePriceDishes,
            toppings: updatePriceToppings,
          } = priceUpdateOrder;
          if (
            !isEmptyObject(outOfStockDishes) ||
            !isEmptyObject(outOfStockToppings) ||
            !isEmptyObject(updatePriceDishes) ||
            !isEmptyObject(updatePriceToppings)
          ) {
            const outOfStock = {};
            const priceUpdates = {};
            // Out of stock
            if (!isEmptyObject(outOfStockDishes)) {
              outOfStock.dishes = outOfStockDishes.map(dish => ({
                dish_id: dish.dishId,
                order_dish_id: dish.orderDishId,
                from: formatDateTime(dish.from),
                to: formatDateTime(dish.to),
              }));
            }
            if (!isEmptyObject(outOfStockToppings)) {
              outOfStock.toppings = outOfStockToppings.map(topping => ({
                topping_id: topping.toppingId,
                order_dish_id: topping.orderDishId,
                from: formatDateTime(topping.from),
                to: formatDateTime(topping.to),
              }));
            }

            // Update price
            if (!isEmptyObject(updatePriceDishes)) {
              priceUpdates.dishes = updatePriceDishes.map(price => ({
                order_dish_id: price.orderDishId,
                dish_id: price.dishId,
                price: price.price,
              }));
            }
            if (!isEmptyObject(updatePriceToppings)) {
              priceUpdates.toppings = updatePriceToppings.map(price => ({
                order_dish_id: price.orderDishId,
                dish_id: price.dishId,
                topping_id: price.toppingId,
                price: price.price,
              }));
            }
            const rejectReasons = {
              type: EnumRejectOrderReason.WRONG_MENU.id,
            };
            if (!isEmptyObject(outOfStock)) {
              rejectReasons.out_of_stock = outOfStock;
            }
            if (!isEmptyObject(priceUpdates)) {
              rejectReasons.price_updates = priceUpdates;
            }
            reqParam.reject_reasons = rejectReasons;
            reqParam.status = EnumOrderUpdateStatus.OUT_OF_SERVICE.id;
          }
          break;
        }
        case EnumRejectOrderReason.RESTAURANT_BUSY.id: {
          reqParam.reject_reasons = {
            type: rejectOrderReason,
            busy_info: {
              total_minute: busyInfoOrder.totalMinute,
            },
          };
          reqParam.status = EnumOrderUpdateStatus.OUT_OF_SERVICE.id;
          break;
        }
        case EnumRejectOrderReason.RESTAURANT_CLOSES.id:
        case EnumRejectOrderReason.WRONG_COMMISSION.id: {
          reqParam.reject_reasons = {
            type: rejectOrderReason,
          };
          reqParam.status = EnumOrderUpdateStatus.OUT_OF_SERVICE.id;
          break;
        }
        case EnumRejectOrderReason.CUSTOM.id: {
          const { customNote } = rejectCustomOrder;
          reqParam.reject_reasons = {
            type: rejectOrderReason,
            custom_note: customNote,
          };
          reqParam.status = EnumOrderUpdateStatus.OUT_OF_SERVICE.id;
          break;
        }
        default: {
          break;
        }
      }
      return reqParam;
    }
    if (validate(objectValidate, setGeneralError)) {
      updateOrderDetailConnect(genBody(this.state, itemDetail));
    }
  };

  // Add out of stock dish, topping to queue
  handleAddOutOfStockList = () => {
    const { outOfStockOrder, outOfStockReq } = this.state;
    const { dishes = [], toppings = [] } = outOfStockOrder;
    const { setGeneralError } = this.props;
    function validate(req) {
      const schema = yup.object().shape({
        from: yup
          .date()
          .max(yup.ref('to'), trans('mod_from_date_to_date_not_correct'))
          .required(),
        to: yup.date().required(),
      });
      try {
        schema.validateSync(req);
        return true;
      } catch (err) {
        setGeneralError(err.errors[0]);
        return false;
      }
    }
    if (validate(outOfStockReq)) {
      if (outOfStockReq.toppingId > 0) {
        this.setState({
          outOfStockOrder: {
            ...outOfStockOrder,
            toppings: [...toppings, outOfStockReq],
          },
          outOfStockReq: {},
        });
      } else {
        this.setState({
          outOfStockOrder: {
            ...outOfStockOrder,
            dishes: [...dishes, outOfStockReq],
          },
          outOfStockReq: {},
        });
      }
    }
  };

  handleRejectOrder = rejectOrderReason => {
    const {
      startConfirmConnect,
      getRestaurantNextOpenTimeConnect,
      itemDetail,
    } = this.props;
    const { rejectOrder } = this.state;
    const { status, is_asap: isASAP } = itemDetail || {};

    this.setState(
      {
        rejectOrder: {
          ...rejectOrder,
          rejectOrderReason,
          isOpenRestaurantClose: false,
        },
        outOfStockOrder: {},
        priceUpdateOrder: {},
      },
      async () => {
        switch (rejectOrderReason) {
          case EnumRejectOrderReason.RESTAURANT_CLOSES.id: {
            if (!isASAP && status === EnumOrderMerchantStatus.VERIFIED.id) {
              await this.setState({
                rejectOrder: {
                  ...rejectOrder,
                  rejectOrderReason,
                },
              });

              this.handleUpdateOrder();

              return;
            }

            getRestaurantNextOpenTimeConnect(itemDetail.restaurant.id).then(
              () => {
                this.setState({
                  rejectOrder: {
                    ...rejectOrder,
                    rejectOrderReason,
                    isOpenRestaurantClose: true,
                  },
                });
              },
            );
            break;
          }
          case EnumRejectOrderReason.WRONG_COMMISSION.id: {
            startConfirmConnect({
              title: trans('mod_reject_wrong_commission'),
              message: trans('mod_are_you_sure_wrong_commission'),
              onOk: () => {
                this.handleUpdateOrder();
              },
              onCancel: () => {
                this.setState({
                  rejectOrder: {
                    ...rejectOrder,
                    rejectOrderReason: EnumRejectOrderReason.CHOOSE_OPTION.id,
                  },
                });
              },
            });
            break;
          }
          default: {
            break;
          }
        }
      },
    );
  };

  handleOpenRejectOrder = isRejectOrder => {
    this.setState(prevState => ({
      rejectOrder: {
        ...prevState.rejectOrder,
        isRejectOrder,
      },
    }));
  };

  handleBusyRestaurant = totalMinute => {
    this.setState(prevState => ({
      busyInfoOrder: {
        ...prevState.rejectOrder,
        totalMinute,
      },
    }));
  };

  handleChangePriceOrder = ({ dishId, orderDishId, toppingId, price }) => {
    const { priceUpdateOrder } = this.state;
    const { toppings = [], dishes = [] } = priceUpdateOrder;
    const reqObj = {
      price,
      dishId,
      orderDishId,
      toppingId,
    };
    if (toppingId > 0) {
      const listTopping = toppings.filter(
        topping => topping.toppingId !== toppingId,
      );
      this.setState({
        priceUpdateOrder: {
          ...priceUpdateOrder,
          toppings: [...listTopping, reqObj],
        },
      });
    } else {
      const listDish = dishes.filter(dish => dish.dishId !== dishId);
      this.setState({
        priceUpdateOrder: {
          ...priceUpdateOrder,
          dishes: [...listDish, reqObj],
        },
      });
    }
  };

  handleCustomRejectOrder = customNote => {
    this.setState(prevState => ({
      rejectCustomOrder: {
        ...prevState.rejectCustomOrder,
        customNote,
      },
    }));
  };

  render() {
    const {
      itemDetail,
      isOpenDialog,
      closeDialogGeneric,
      setGeneralError,
      setEditDishOutOfStockConnect,
      dialog,
      startTransferringOrderConnect,
      transferredOrder,
    } = this.props;
    const { itemDish, nextOpenTime } = dialog;
    const {
      merchantNote,
      pickTime,
      outOfStockReq,
      outOfStockOrder,
      rejectOrder,
      busyInfoOrder,
      priceUpdateOrder,
      rejectCustomOrder,
    } = this.state;
    const {
      isRejectOrder,
      rejectOrderReason,
      isOpenRestaurantClose,
    } = rejectOrder;

    if (isEmptyObject(itemDetail)) {
      return null;
    }

    const {
      code,
      status,
      first_seen_user: firstSeenUser,
      restaurant,
      order_user: orderUser,
      customer_pay: customerPay = {},
      allow_cancel: allowCancel,
    } = itemDetail;
    const isHaveChangeOrder = [
      EnumOrderMerchantStatus.M_ASSIGNED.id,
      EnumOrderMerchantStatus.M_RECEIVED.id,
      EnumOrderMerchantStatus.M_TIMEOUT.id,
    ].includes(status);

    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenDialog}
          className={`modal-order-detail ${
            transferredOrder ? 'modal-order-detail-hidden' : ''
          }`}
          onRequestClose={() => closeDialogGeneric()}
        >
          <ModalHeader>
            <TitlePopupModal
              code={code}
              status={status}
              name={restaurant.name}
              allowCancel={allowCancel}
            />
          </ModalHeader>
          <ModalBody>
            <div
              className="row mb-1 align-items-center"
              style={{ borderBottom: '1px solid #efefef', margin: '0 6px' }}
            >
              <CustomerInfo orderUser={orderUser} customerPay={customerPay} />
              {!isEmptyObject(firstSeenUser) && (
                <FirstSeenUser firstSeenUser={firstSeenUser} />
              )}
            </div>
            <OrderDetailTable
              isHaveChangeOrder={isHaveChangeOrder}
              itemDetail={itemDetail}
              outOfStockOrder={outOfStockOrder}
              handleOpenOutOfStockModal={this.handleOpenOutOfStockModal}
            />
            <OrderDetailInfo
              isHaveChangeOrder={isHaveChangeOrder}
              itemDetail={itemDetail}
              merchantNote={merchantNote || ''}
              pickTime={pickTime}
              handleChangePickTime={this.handleChangePickTime}
              handleChangeMerchantNote={this.handleChangeMerchantNote}
            />
          </ModalBody>
          {(isHaveChangeOrder ||
            status === EnumOrderMerchantStatus.CONFIRMED.id ||
            status === EnumOrderMerchantStatus.VERIFIED.id) && (
            <ModalAction>
              <OrderDetailAction
                isHaveChangeOrder={isHaveChangeOrder}
                itemDetail={itemDetail}
                handleTransferOrder={() =>
                  startTransferringOrderConnect(itemDetail)
                }
                handleUpdateOrder={this.handleUpdateOrder}
                handleOpenRejectOrder={this.handleOpenRejectOrder}
              />
            </ModalAction>
          )}
        </Modal>
        <RejectOrderModal
          itemDetail={itemDetail}
          isOpenDialog={isRejectOrder}
          handleRejectOrder={this.handleRejectOrder}
          handleOpenRejectOrder={this.handleOpenRejectOrder}
        />
        <RejectOrderDishModal
          itemDetail={itemDetail}
          outOfStockOrder={outOfStockOrder}
          priceUpdateOrder={priceUpdateOrder}
          handleOpenOutOfStockModal={this.handleOpenOutOfStockModal}
          isOpenDialog={
            rejectOrderReason === EnumRejectOrderReason.WRONG_MENU.id
          }
          handleRejectOrder={this.handleRejectOrder}
          setEditDishOutOfStock={setEditDishOutOfStockConnect}
          itemDish={itemDish}
          handleChangePriceOrder={this.handleChangePriceOrder}
          handleUpdateOrder={this.handleUpdateOrder}
        />
        <RejectOrderBusyModal
          isOpenDialog={
            rejectOrderReason === EnumRejectOrderReason.RESTAURANT_BUSY.id
          }
          handleUpdateOrder={this.handleUpdateOrder}
          handleRejectOrder={this.handleRejectOrder}
          busyInfoOrder={busyInfoOrder}
          setGeneralError={setGeneralError}
          handleBusyRestaurant={this.handleBusyRestaurant}
        />
        <OutOfStockDishModal
          outOfStockReq={outOfStockReq}
          handleChangeOutOfStock={this.handleChangeOutOfStock}
          handleAddOutOfStockList={this.handleAddOutOfStockList}
        />
        <RejectOrderRestaurantCloseModal
          isOpenDialog={
            rejectOrderReason === EnumRejectOrderReason.RESTAURANT_CLOSES.id &&
            isOpenRestaurantClose
          }
          nextOpenTime={nextOpenTime}
          handleUpdateOrder={this.handleUpdateOrder}
          handleRejectOrder={this.handleRejectOrder}
        />
        <RejectOrderCustomModal
          isOpenDialog={rejectOrderReason === EnumRejectOrderReason.CUSTOM.id}
          rejectCustomOrder={rejectCustomOrder}
          handleCustomRejectOrder={this.handleCustomRejectOrder}
          handleUpdateOrder={this.handleUpdateOrder}
          handleRejectOrder={this.handleRejectOrder}
        />
        <TransferOrderModal />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  transferredOrder: state.transferOrder.transferredOrder,
});

const mapDispatchToProps = {
  updateOrderDetailConnect: updateOrderDetail,
  setEditDishOutOfStockConnect: setEditDishOutOfStock,
  startConfirmConnect: startConfirm,
  getRestaurantNextOpenTimeConnect: getRestaurantNextOpenTime,
  startTransferringOrderConnect: startTransferringOrder,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderDetailModal),
);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/OrderDetailModal.jsx